/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { StickyBottomHelper, Button } from 'sarsaparilla';
import PropTypes from 'prop-types';
import { gnoment } from 'shared-ui/gnoment';

import AvailabilityLegend from './AvailabilityLegend';

const propTypes = {
    selectedDivision: PropTypes.object,
    selectedStartDate: PropTypes.string,
    selectedEndDate: PropTypes.string,
    selectedDivision2: PropTypes.object,
    selectedStartDate2: PropTypes.string,
    selectedEndDate2: PropTypes.string,
    isMultiDestination: PropTypes.bool,
    isEnabled: PropTypes.bool,
    onBookClick: PropTypes.func,
};

const defaultProps = {
    isEnabled: false,
};

export default class BookNowComponent extends React.Component {
    render() {
        let labels = null;
        if (!this.props.isMultiDestination) {
            labels = (
                <ul>
                    <li>
                        {this.props.selectedDivision && this.props.selectedDivision.name}
                    </li>
                    <li>
                        {this.props.selectedDivision &&
                            this.props.selectedStartDate &&
                            gnoment(this.props.selectedStartDate)
                                .utc()
                                .startOf('day')
                                .format('MM/DD/YYYY')}
                        {this.props.selectedDivision &&
                            this.props.selectedEndDate &&
                            ` - ${gnoment(this.props.selectedEndDate).utc().startOf('day').format('MM/DD/YYYY')}`}
                    </li>
                </ul>
            );
        }
        if (this.props.isMultiDestination) {
            labels = (
                <ul>
                    <li>
                        {this.props.selectedDivision &&
                            `To: ${this.props.selectedDivision.name}`}
                        {this.props.selectedDivision &&
                            this.props.selectedStartDate &&
                            ` | ${gnoment(this.props.selectedStartDate).utc().startOf('day').format('MM/DD/YYYY')}`}
                    </li>
                    <li>
                        {this.props.selectedDivision2 &&
                            `From: ${this.props.selectedDivision2.name}`}
                        {this.props.selectedDivision2 &&
                            this.props.selectedStartDate2 &&
                            ` | ${gnoment(this.props.selectedStartDate2).utc().startOf('day').format('MM/DD/YYYY')}`}
                    </li>
                </ul>
            );
        }

        return (
            <StickyBottomHelper scrollingContainerId="per-availability-main">
                <div className="per-availability-book-now">
                    <div className="per-availability-book-now-content">
                        <AvailabilityLegend />
                        <div className="selection-information">{labels}</div>
                        <Button
                            onClick={this.props.onBookClick}
                            isDisabled={!this.props.isEnabled}
                        >
                            Book Now
                        </Button>
                    </div>
                </div>
            </StickyBottomHelper>
        );
    }
}

BookNowComponent.propTypes = propTypes;
BookNowComponent.defaultProps = defaultProps;
